import { isRetailer } from "./getRetailer";
export var hasShortcutsAccess = function hasShortcutsAccess() {
  return isRetailer();
};